import React from 'react'
import Slider from "react-slick";
import { FaGithub, FaExternalLinkAlt } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Ducati from "../assets/images/ducati.png";
import Movie from "../assets/images/Movie.png";
import Conference from "../assets/images/ConferencePage.png";

const projects = [
  {
    title: "Ducati Bikes Reservations",
    description: "A simple, responsive website that serves a user to add/remove bikes reservations. It is a full stack application built with Rails as a backend and React as a frontend.",
    image: `${Ducati}`,
    techstacks: ["React", "Redux", "Rails"],
    github: "https://github.com/AbrahaKahsay/final-capstone-frontend",
    livedemo: "https://ducati-rentals.netlify.app/",
  },
  {
    title: "Movies App",
    description: "A interactive web application based on an external API that allows a user to like, comment and reserve a movie.",
    image: `${Movie}`,
    techstacks: ["JavaScript", "HTML5", "CSS3", "API"],
    github: "https://github.com/AbrahaKahsay/Capstone-API-based-webapp",
    livedemo:
      "https://for-ashraf.github.io/Capstone-Project-2---API-based-webapp/dist/index.html",
  },
  {
    title: "Conference Summit Page",
    description: "A simple, responsive website built to organize a conference. It is built with HTML and Vanilla JavaScript.",
    image: `${Conference}`,
    techstacks: ["HTML5", "CSS3", "JavaScript"],
    github: "https://github.com/AbrahaKahsay/capstone-1-conference-page",
    livedemo: "https://abrahakahsay.github.io/capstone-1-conference-page/",
  },
];

const ProjectCard = ({ project }) => {
  return (
    <div className="bg-white rounded shadow p-4 mx-4 mb-4 max-w-2xl">
      <div
        className="w-full h-48 mb-2"
        style={{
          backgroundImage: `url(${project.image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <h3 className="text-xl font-bold mb-2">{project.title}</h3>
      <p className="text-gray-700 mb-2 text-sm h-20 overflow-hidden">{project.description}</p>
      <div className="flex flex-wrap mb-2">
        {project.techstacks.map((techstack, index) => (
          <span
            key={index}
            className="bg-gray-200 px-2 py-1 text-sm text-gray-700 mr-2 mb-1"
          >
            {techstack}
          </span>
        ))}
      </div>
      <div className="flex">
        {project.github && (
          <a
            href={project.github}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center bg-gray-700 text-white rounded-full py-1 px-2 mr-4 hover:bg-gray-500 transition duration-300 ease-in-out"
          >
            <FaGithub size={15} className="mr-2" />
            <span className="text-sm">GitHub</span>
          </a>
        )}
        {project.livedemo && (
          <a
            href={project.livedemo}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center bg-gray-700 text-white rounded-full py-1 px-2 hover:bg-gray-500 transition duration-300 ease-in-out"
          >
            <FaExternalLinkAlt size={15} className="mr-2" />
            <span className="text-sm">Live Demo</span>
          </a>
        )}
      </div>
    </div>
  );
};

const Projects = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          arrows: false,
        },
      },
    ],
  };

  return (
    <section className="bg-gray-900 mx-auto px-6 min-h-screen py-20" id="projects">
      <div className="container mx-auto max-w-5xl">
        <h2 className="text-3xl font-bold text-white pt-2 mb-16 text-center" style={{ color: "rgb(92, 225, 230)" }}>
          My Projects
        </h2>
        <Slider {...settings}>
          {projects.map((project, index) => (
            <ProjectCard key={index} project={project} />
          ))}
        </Slider>
        <div className="flex mt-10 mb-10 justify-start">
          <a
            href="https://www.github.com/AbrahaKahsay"
            className="bg-teal-600 hover:bg-teal-700 text-white font-bold py-2 px-4 rounded-full justify-center sm:justify-start"
          >
            Show all projects
          </a>
        </div>
      </div>
    </section>
  );
};

export default Projects;
